<div class="page-break-title">
  <h1>{{pageBreakRules.title}}<sup *ngIf="isBaskBrand">&reg;</sup></h1>
</div>
<div [ngClass]="{'page-break': true, 'page-break-with-padding': isBaskBrand}">
  <ng-container *ngIf="isBaskBrand">
    <h3 class="page-break-accent-info">Apply for an account in minutes.</h3>
  </ng-container>
  <div class="page-break-required-info">
    <h2 class="page-break-subtitle">{{pageBreakRules.subTitle}}</h2>
    <div class="required-info-container" fxLayout="column" fxLayout.gt-xs="row" fxLayoutAlign="center center"
         fxLayoutGap="10px" fxLayoutGap.gt-xs="20px">
      <div fxFlex="33.3" fxLayout="row" fxLayout.gt-xs="column"
           [fxLayoutAlign]="isBaskBrand? 'start center' : 'center start'"
           fxLayoutAlign.gt-xs="center center" fxLayoutGap="10px">
        <div class="img-container" fxLayout="row" fxLayoutAlign="center center">
          <img class="page-break-image" [src]="pageBreakRules.ssImage" alt="Social security number">
        </div>
        <div>
          <h4 class="page-break-info-title">Social Security Number</h4>
          <p class="page-break-info">Applicants must be 18 years or older and provide a valid SSN.</p>
        </div>
      </div>
      <div fxFlex="33.3" fxLayout="row" fxLayout.gt-xs="column"
           [fxLayoutAlign]="isBaskBrand? 'start center' : 'center center'"
           fxLayoutAlign.gt-xs="center center" fxLayoutGap="10px">
        <div class="img-container" fxLayout="row" fxLayoutAlign="center center">
          <img class="page-break-image" [src]="pageBreakRules.idImage" alt="U.S. government ID">
        </div>
        <div>
          <h4 class="page-break-info-title">{{pageBreakRules.idTitle}}</h4>
          <ng-container *ngIf="isBaskBrand; else isTcbBrand">
            <p class="page-break-info">For a list of accepted forms of identification, refer to the <strong>Open an
              Account</strong> section of our
              <a class="link-btn-action"
                 [href]="pageBreakRules.faqUrl"
                 target="_blank" rel="noopener noreferrer">FAQs</a>.</p>
          </ng-container>
          <ng-template #isTcbBrand>
            <p class="page-break-info">Visit our Personal Banking <a class="accent-link"
                                                                     [href]="pageBreakRules.faqUrl"
                                                                     target="_blank" rel="noopener noreferrer">FAQs</a>
              for a list of accepted
              forms of identification.</p>
          </ng-template>
        </div>
      </div>
      <div fxFlex="33.3" fxLayout="row" fxLayout.gt-xs="column"
           [fxLayoutAlign]="isBaskBrand? 'start center' : 'center center'"
           fxLayoutAlign.gt-xs="center center" fxLayoutGap="10px">
        <div class="img-container" fxLayout="row" fxLayoutAlign="center center">
          <img class="page-break-image" [src]="pageBreakRules.mobileImage" alt="Mobile device">
        </div>
        <div>
          <h4 class="page-break-info-title">Mobile Device</h4>
          <p class="page-break-info">{{pageBreakRules.mobileDescription}}</p>
        </div>
      </div>
    </div>
    <mat-divider class="page-break-accent-line"></mat-divider>
    <ng-container *ngIf="!isBaskBrand">
      <h3 class="page-break-accent-info">Apply for an account in minutes</h3>
    </ng-container>
    <div class="continue-button">
      <button class="primary-btn-action" (click)="onClickOfGetStarted()" mat-flat-button color="primary" [mat-dialog-close]="true">
        {{ isForJointMaintenance ? "Continue" : "Get Started" }}
      </button>
    </div>
  </div>
</div>
